import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50/80 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px]">
          <i className="ri-global-line text-background-50 text-[800px]"></i>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mb-4 cursor-pointer"
            >
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                Superbuy Sheet
              </span>
              <span className="w-2 h-2 rounded-full bg-primary-500 ml-1"></span>
            </a>
            <p className="text-sm text-background-50/60 leading-relaxed mb-6 max-w-sm">
              Your trusted hub for Superbuy spreadsheet collections, product guides, and smart shopping resources. Updated weekly with the latest finds.
            </p>
            <div className="flex items-center gap-3">
              {['ri-twitter-x-line', 'ri-instagram-line', 'ri-pinterest-line', 'ri-youtube-line'].map((icon) => (
                <a
                  key={icon}
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-lg border border-background-50/15 flex items-center justify-center hover:bg-background-50/10 transition-all cursor-pointer"
                >
                  <i className={`${icon} text-background-50/70 text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50 mb-4">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {['Shoes', 'Hoodies', 'T-Shirts', 'Jackets', 'Accessories'].map((item) => (
                <li key={item}>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50 mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/superbuy-spreadsheet-guide"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Complete Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Superbuy Sheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-50 mb-4">
              Legal
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Terms of Service
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-50/10 gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 superbuyspread.site. All rights reserved. This site is an independent resource and is not affiliated with Superbuy.
          </p>
          <p className="text-xs text-background-50/30">
            Built for Superbuy Spreadsheet enthusiasts
          </p>
        </div>
      </div>
    </footer>
  );
}